import { GlobalOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Typography } from 'antd';

export const LanguageSelector = ({
  changeLanguage,
}: {
  changeLanguage: (language: string) => void;
}) => {
  const items: MenuProps['items'] = ['en-US', 'fr-FR', 'de-DE'].map(
    (language, index) => {
      return {
        key: language,
        label: (
          <Typography.Text onClick={() => changeLanguage(language)}>
            {language.slice(0, 2).toLocaleUpperCase()}
          </Typography.Text>
        ),
      };
    },
  );

  return (
    <Dropdown
      placement="bottom"
      menu={{ items }}
      trigger={['click']}
      getPopupContainer={(trigger) => trigger}
    >
      <Button size="large" icon={<GlobalOutlined />} type="text" />
    </Dropdown>
  );
};
